// extracted by mini-css-extract-plugin
export default {"listItem":"RecentListItem_listItem__g-Jpo","icon":"RecentListItem_icon__OBqHF"};